import styled from 'styled-components'

const MyDiv = styled.div`
.icn_style2{
    color: #F50057;
}

`
export default MyDiv
